const config = {
    redirects: {
        app: 'https://app.ginastee.com',
        android: 'https://play.google.com/store/apps/details?id=com.ginastee',
        ios: 'https://apps.apple.com/br/app/ginastee/id6448853593',

        support: 'https://api.whatsapp.com/send/?phone=5531971583279',
        helpDesk: "https://ginastee.frontkb.com/pt-BR",


        openApp() {
            window.location.href = config.redirects.app;
        },
        openAndroid() {
            window.location.href = config.redirects.android;
        },
        openIos() {
            window.location.href = config.redirects.ios;
        },
        openSupport() {
            window.location.href = config.redirects.support;
        },
        openHelpDesk() {
            window.location.href = config.redirects.helpDesk;
        }
    },
};

export default config;